import type { ReactNode } from "react";

// Ported from apps/frontend. The marker-pen highlight behind a phrase in the
// hero and section headings.
//
// `box-decoration-break: clone` is the load-bearing part: without it a
// highlight that wraps onto a second line loses its padding and rounding on the
// break, which is far more visible in Persian than in English because the text
// wraps more often.
const COLORS: Record<string, string> = {
  navy: "bg-brand-navy",
  red: "bg-brand-red",
  sky: "bg-brand-sky",
};

export default function InlineHighlight({
  children,
  color = "navy",
  className = "",
}: {
  children: ReactNode;
  color?: string;
  className?: string;
}) {
  return (
    <span
      className={`${COLORS[color] || COLORS.navy} text-white px-3 py-1 inline-block rounded-[0.25em] ${className}`}
      style={{ boxDecorationBreak: "clone", WebkitBoxDecorationBreak: "clone" }}
    >
      {children}
    </span>
  );
}
